export default [
    {
        title: 'Lead Config Information',
        arr: [
            {
                key: 'source_key',
                fakeKey: 'sourceKey',
                label: 'Source Key',
                type: 'text',
                val: '',
                required: true
            },
            {
                key: 'ping_tree',
                fakeKey: 'pingTree',
                label: 'Ping Tree',
                type: 'autoComplete',
                val: 'allPingTree',
                returnKey: 'id',
                displayKey: 'id',
                required: false
            },
            {
                key: 'referring_site_url',
                fakeKey: 'referringSiteUrl',
                label: 'Referring Site URL',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'source_sub_code_1',
                fakeKey: 'sourceSubCode1',
                label: 'Source Sub Code 1',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'source_sub_code_2',
                fakeKey: 'sourceSubCode2',
                label: 'Source Sub Code 2',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'source_sub_code_3',
                fakeKey: 'sourceSubCode3',
                label: 'Source Sub Code 3',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'source_lead_id',
                fakeKey: 'sourceLeadId',
                label: 'Source Lead Id',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'everflow_transaction_id',
                fakeKey: 'everflowTransactionId',
                label: 'Everflow Transaction Id',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'minimum_price',
                fakeKey: 'minimumPrice',
                label: 'Minimum Price',
                type: 'number',
                val: '',
                required: false
            },
            // {
            //     key: 'timeout',
            //     fakeKey: 'timeout',
            //     label: 'Timeout',
            //     type: 'number',
            //     val: '',
            //     required: false
            // },
            {
                key: 'minimum_loan_amount',
                fakeKey: 'minimumLoanAmount',
                label: 'Minimum Loan Amount',
                type: 'number',
                val: '',
                required: false
            },
            {
                key: 'maximum_loan_amount',
                fakeKey: 'maximumLoanAmount',
                label: 'Maximum Loan Amount',
                type: 'number',
                val: '',
                required: false
            },
            {
                key: 'test_app',
                fakeKey: 'isTestApp',
                label: 'Is Test App',
                type: 'switch',
                val: true,
                required: false
            },
            {
                key: 'bypass_filter',
                fakeKey: '',
                label: 'Bypass Filter',
                type: 'switch',
                val: false,
                required: false
            },
            {
                key: 'date_created_effective',
                fakeKey: 'dateCreatedEffective',
                label: 'Date Created Effective',
                type: 'dateTime',
                val: '',
                required: false
            }
        ]
    },
    {
        title: 'User Information',
        arr: [
            {
                key: 'first_name',
                fakeKey: 'firstName',
                label: 'First Name',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'middle_name',
                fakeKey: 'middleName',
                label: 'Middle Name',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'last_name',
                fakeKey: 'lastName',
                label: 'Last Name',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'primary_email',
                fakeKey: 'primaryEmail',
                label: 'Primary Email',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'home_phone',
                fakeKey: 'homePhone',
                label: 'Home Phone',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'mobile_phone',
                fakeKey: 'mobilePhone',
                label: 'Mobile Phone',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'best_call_time',
                fakeKey: 'bestCallTime',
                label: 'Best Call Time',
                type: 'autoComplete',
                val: [
                    'MORNING', 'AFTERNOON', 'EVENING'
                ],
                required: false
            },
            {
                key: 'date_of_birth',
                fakeKey: 'dateOfBirth',
                label: 'Date of Birth',
                type: 'date',
                dateFormat: 'yyyy-MM-dd',
                val: '',
                required: true
            },
            {
                key: 'ssn',
                fakeKey: 'ssn',
                label: 'SSN',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'street_address',
                fakeKey: 'streetAddress',
                label: 'Street Address',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'street_address2',
                fakeKey: 'streetAddress2',
                label: 'Street Address 2',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'city',
                fakeKey: 'city',
                label: 'City',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'state',
                fakeKey: 'state',
                label: 'State',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'zip',
                fakeKey: 'zip',
                label: 'Zip',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'residence_type',
                fakeKey: 'residenceType',
                label: 'Residence Type',
                type: 'autoComplete',
                val: ['RENT', 'OWN'],
                required: true
            },
            {
                key: 'residence_length_months',
                fakeKey: 'residenceLengthMonths',
                label: 'Residence Length Months',
                type: 'number',
                val: '',
                required: true
            },
            {
                key: 'military',
                fakeKey: 'military',
                label: 'Military',
                type: 'switch',
                val: false,
                required: true
            },
            {
                key: 'state_id_number',
                fakeKey: 'stateIdNumber',
                label: 'State Id Number',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'state_id_issued',
                fakeKey: 'stateIdIssued',
                label: 'State Id Issued',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'credit_score',
                fakeKey: 'creditScore',
                label: 'Credit Score',
                type: 'autoComplete',
                val: [
                    'EXCELLENT', 'VERY_GOOD', 'GOOD', 'FAIR', 'POOR'
                ],
                required: true
            },
            {
                key: 'user_agent',
                fakeKey: 'userAgent',
                label: 'User Agent',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'client_ip_address',
                fakeKey: 'clientIpAddress',
                label: 'Client IP Address',
                type: 'string',
                val: '',
                required: true
            },
        ]
    },
    {
        title: 'Bank Information',
        arr: [
            {
                key: 'bank_name',
                fakeKey: 'bankName',
                label: 'Bank Name',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'bank_routing',
                fakeKey: 'bankRouting',
                label: 'Bank Routing',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'bank_account',
                fakeKey: 'bankAccount',
                label: 'Bank Account',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'bank_account_type',
                fakeKey: 'bankAccountType',
                label: 'Bank Account Type',
                type: 'autoComplete',
                val: [
                    'CHECKING', 'SAVINGS'
                ],
                required: true
            },
            {
                key: 'months_at_bank',
                fakeKey: 'monthsAtBank',
                label: 'Months At Bank',
                type: 'number',
                val: '',
                required: false
            },
        ]
    },
    {
        title: 'Employment Information',
        arr: [
            {
                key: 'employment_type',
                fakeKey: 'employmentType',
                label: 'Employment Type',
                type: 'autoComplete',
                val: [
                    'EMPLOYED', 'BENEFITS', 'SELF_EMPLOYED'
                ],
                required: true
            },
            {
                key: 'employer_name',
                fakeKey: 'employerName',
                label: 'Employment Name',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'employer_length_months',
                fakeKey: 'employerLengthMonths',
                label: 'Employment Length Months',
                type: 'number',
                val: '',
                required: true
            },
            {
                key: 'work_phone',
                fakeKey: 'workPhone',
                label: 'Work Phone',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'work_ext',
                fakeKey: 'workExt',
                label: 'Work Ext',
                type: 'string',
                val: '',
                required: false
            },
            {
                key: 'pay_frequency',
                fakeKey: 'payFrequency',
                label: 'Pay Frequency',
                type: 'autoComplete',
                val: [
                    'WEEKLY', 'BIWEEKLY', 'SEMI_MONTHLY', 'MONTHLY'
                ],
                required: true
            },
            {
                key: 'monthly_income',
                fakeKey: 'monthlyIncome',
                label: 'Monthly Income',
                type: 'string',
                val: '',
                required: true
            },
            {
                key: 'pay_type',
                fakeKey: 'payType',
                label: 'Pay Type',
                type: 'autoComplete',
                val: [
                    'DIRECT_DEPOSIT', 'PAPER_CHECK'
                ],
                required: true
            },
            {
                key: 'next_pay_date',
                fakeKey: 'nextPayDate',
                label: 'Next Pay Date',
                type: 'date',
                dateFormat: 'yyyy-MM-dd',
                val: '',
                required: true
            },
            {
                key: 'second_pay_date',
                fakeKey: 'secondPayDate',
                label: 'Second Pay Date',
                type: 'date',
                dateFormat: 'yyyy-MM-dd',
                val: '',
                required: true
            },
        ]
    },
]